module.exports = __webpack_public_path__ + "img/img_20.4cddd33b.jpg";